import { Component, Input } from '@angular/core';

import { Position } from '../../models/cutting/cutting-svg.model';

@Component({
  selector: 'csl-base-point-thumbnail',
  templateUrl: './base-point-thumbnail.component.html',
  styleUrls: ['./base-point-thumbnail.component.scss'],
})
export class BasePointThumbnailComponent {
  @Input() active: Position = undefined;

  @Input() showAxis = true;
}
